import s from './ProfileDoc.module.scss';

/**
 * The document design's layout classes — `.detail`, `.section`, `.grid`,
 * `.entry` and friends — for screens that arrange the cards themselves. Its own
 * module rather than an export of ProfileDoc so that file stays components-only
 * (react-refresh).
 */
export const docStyles = s;
